export default "__VITE_ASSET__CN8KX85c__"